import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
} from "@mui/material";
import PortraitIcon from "@mui/icons-material/Portrait";
import { modalstyle, muiAbtn, muiBbtn } from "./style";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import AddIcon from "@mui/icons-material/Add";
import Rating from "@mui/material/Rating";
import CreativeImage from "./CreativeImage";
import { getFunctions, httpsCallable } from "firebase/functions";

import {
  collection,
  getDocs,
  setDoc,
  addDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  deleteDoc,
  onSnapshot,
  limit,
  where,
  getDoc,
} from "firebase/firestore";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db, storage } from "../firebase";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CircleIcon from "@mui/icons-material/Circle";

import {
  getDownloadURL,
  uploadBytesResumable,
  ref,
  uploadBytes,
} from "firebase/storage";
import { useAuth } from "./AuthContext";
import ProgressBar from "./ProgressBar";
import CircularProgress from "@mui/material/CircularProgress";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
  p: 4,
  borderRadius: 2,
};

export default function Categories() {
  const { ResetPassword } = useAuth();

  const functions = getFunctions();
  const updateUserData = httpsCallable(functions, "updateUserData");
  const getUserEmailVerification = httpsCallable(functions, "getUserEmailVerification");

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateID, setupdateID] = useState(-1);
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [UploadImage, setUploadImage] = useState(null);
  const [gender, setGender] = useState("");
  const [Profile, setProfile] = useState("");
  const [UploadProgress, setUploadProgress] = useState(0);
  const [status, setstatus] = useState(false);
  const [isProcessing, setisProcessing] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  
  // State for complete user data
  const [fullUserData, setFullUserData] = useState({});
  const [securityData, setSecurityData] = useState(null);
  
  // Helper function to determine user type
  const getUserType = (userData) => {
    const types = [];
    
    if (userData?.hasDiplomaticStatus) {
      types.push('Diplomatic User');
    }
    if (userData?.subscription) {
      types.push('Premium User');
    }
    if (types.length === 0) {
      types.push('Simple User');
    }
    
    return types;
  };
  
  // Helper function to render field value
  const renderFieldValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return <span className="text-muted">N/A</span>;
    }
    if (typeof value === 'boolean') {
      return value ? (
        <span style={{ color: '#2e7d32', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
          <CheckCircleIcon sx={{ fontSize: '16px', mr: 0.5 }} /> Yes
        </span>
      ) : (
        <span style={{ color: '#d32f2f', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
          <CancelIcon sx={{ fontSize: '16px', mr: 0.5 }} /> No
        </span>
      );
    }
    if (value?.seconds) {
      return new Date(value.seconds * 1000).toLocaleString();
    }
    if (value instanceof Date) {
      return value.toLocaleString();
    }
    if (Array.isArray(value)) {
      return value.length > 0 ? `${value.length} item(s)` : <span className="text-muted">Empty</span>;
    }
    if (typeof value === 'object') {
      return JSON.stringify(value).substring(0, 50) + '...';
    }
    return String(value);
  };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      onSnapshot(
        query(collection(db, "users"), orderBy("created_on", "desc")),
        (data) => {
          const fetchedRows = data.docs.map((document) => ({
            ...document.data(),
            id: document.id,
          }));
          setRows(fetchedRows);
          setLoading(false);
        }
      );
    };
    getData();
  }, []);

  const [open, setOpen] = useState(false);
  const [SelectedUser, setSelectedUser] = useState("");
  const [openView, setOpenView] = useState(false);

  const fetchUserData = async (index) => {
    const docRef = doc(db, "users", index);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      const data = docSnap.data();
      
      // Store form fields for editing
      setName(data.displayName || "");
      setEmail(data.email || "");
      setPhone(data.phoneNumber || "");
      setstatus(data.disabled || false);
      setGender(data.gender || "");
      setProfile(data.photoURL || "");
      
      // Load the registrationSecurity JSON
      if (data.registrationSecurity) {
        setSecurityData(data.registrationSecurity);
      } else {
        setSecurityData(null);
      }
      
      // Fetch email verification from Firebase Auth via Cloud Function
      if (data.email) {
        try {
          const result = await getUserEmailVerification({ email: data.email });
          const verified = result.data?.emailVerified || false;
          setEmailVerified(verified);
          
          // Store complete user data with emailVerified from Auth
          setFullUserData({
            ...data,
            emailVerified: verified,
          });
        } catch (error) {
          console.error("Error fetching email verification:", error);
          setEmailVerified(false);
          setFullUserData({
            ...data,
            emailVerified: false,
          });
        }
      } else {
        setFullUserData(data);
      }
    }
  };

  const resetForm = () => {
    setName("");
    setEmail("");
    setPhone("");
    setstatus(false);
    setGender("");
    setProfile("");
    setSecurityData(null);
    setEmailVerified(false);
    setUploadProgress(0);
  };

  const handleOpen = async (index) => {
    setupdateID(index);
    setOpen(true);
    fetchUserData(index);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenView(false);
    resetForm();
  };

  const handleOpenView = (index) => {
    setOpenView(true);
    fetchUserData(index);
  };

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpen = (id) => {
    setOpenDialog(true);
    setSelectedUser(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedUser("");
  };

  const deleteUser = () => {
    deleteDoc(doc(db, "users", SelectedUser))
      .then(() => {
        toast.info("User Deleted");
        handleCloseDialog();
      })
      .catch((error) => {
        toast.error("Error! Failed to delete user");
      });
  };

  const updateUser = () => {
    setisProcessing(true);
    let data = {
      displayName: Name,
      email: Email,
      phoneNumber: Phone,
      gender: gender,
      photoURL: Profile,
      updated: new Date(),
      uid: updateID,
      disabled: status,
    };

    if (UploadImage) {
      const storageRef = ref(storage, `/profile_images/profile_image_user_${updateID}`);
      const uploadTask = uploadBytesResumable(storageRef, UploadImage);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          setUploadProgress(percent);
        },
        (err) => {
          console.log(err);
          setisProcessing(false);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            data.photoURL = url;
            updateUserData(data).then(() => {
              updateDoc(doc(db, "users", updateID), data).then(() => {
                setisProcessing(false);
                toast.info("User Updated");
                handleClose();
              });
            });
          });
        }
      );
    } else {
      updateUserData(data)
        .then(() => {
          updateDoc(doc(db, "users", updateID), data).then(() => {
            setisProcessing(false);
            toast.info("User Updated");
            handleClose();
          });
        })
        .catch((error) => {
          setisProcessing(false);
          toast.error(error.message);
        });
    }
  };

  const sendLink = () => {
    ResetPassword(Email)
      .then(() => {
        toast.success("Link Has Been Sent To " + Email);
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  const columns = [
    {
      field: "Profile",
      headerName: "",
      width: 500,
      align: "left",
      renderCell: profileCell,
    },
    {
      field: "Action",
      width: 400,
      align: "right",
      renderCell: ActionButton,
    },
  ];

  function profileCell(params) {
    return (
      <div className="row">
        <div className="col-4">
          <img
            width="50px"
            className="rounded-4"
            height="50px"
            src={params.row.photoURL || "https://via.placeholder.com/50"}
            alt="profile"
          />
        </div>
        <div className="col-8 d-flex justify-content-left flex-wrap align-items-center">
          <span className="ms-1">
            <b>{params.row.displayName}</b>
            <br />
            <small className="text-muted">
              {params.row.created_on 
                ? new Date(params.row.created_on.seconds * 1000).toLocaleDateString()
                : "N/A"}
              <FiberManualRecordIcon sx={{ fontSize: "5px", mx: 1 }} />
              <b role="button" onClick={() => handleOpenView(params.row.id)}>
                Details
              </b>
            </small>
          </span>
        </div>
      </div>
    );
  }

  function ActionButton(params) {
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          onClick={() => handleOpen(params.row.id)}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          onClick={() => handleClickOpen(params.row.id)}
        >
          Delete
        </Button>
      </>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        backgroundColor: "#212C62",
        minHeight: "100vh"
      }}
    >
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{"Are you sure to Delete the User?"}</DialogTitle>
        <DialogActions>
          <Button onClick={() => deleteUser()}>Yes</Button>
          <Button onClick={handleCloseDialog} autoFocus>No</Button>
        </DialogActions>
      </Dialog>

      <ToastContainer position="top-center" theme="colored" />

      {/* EDIT MODAL */}
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <form>
            <Box mb={3} style={{ display: "flex", justifyContent: "end" }}>
              <CloseIcon onClick={handleClose} style={{ cursor: "pointer", color: "gray" }} />
            </Box>
            <FormControl fullWidth size="small">
              <TextField className="mb-4" label="Name" size="small" fullWidth value={Name} onChange={(e) => setName(e.target.value)} />
            </FormControl>
            <FormControl fullWidth size="small">
              <TextField className="mb-4" label="Email" size="small" fullWidth value={Email} onChange={(e) => setEmail(e.target.value)} />
            </FormControl>
            <FormControl fullWidth size="small">
              <TextField className="mb-4" label="Phone" size="small" fullWidth value={Phone} onChange={(e) => setPhone(e.target.value)} />
            </FormControl>
            <div className="row">
              <div className="col">
                <FormControl fullWidth className="mb-4" size="small">
                  <InputLabel>Status</InputLabel>
                  <Select value={status} label="Status" onChange={(e) => setstatus(e.target.value)}>
                    <MenuItem value={false}>Active</MenuItem>
                    <MenuItem value={true}>Disable</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="col">
                <FormControl fullWidth className="mb-4" size="small">
                  <InputLabel>Gender</InputLabel>
                  <Select value={gender} label="Gender" onChange={(e) => setGender(e.target.value)}>
                    <MenuItem value={"Male"}>Male</MenuItem>
                    <MenuItem value={"Female"}>Female</MenuItem>
                    <MenuItem value={"Other"}>Other</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="mb-4">
              <label className="form-label"><b>Change Profile</b></label>
              <input type="file" accept="image/*" className="form-control" onChange={(e) => setUploadImage(e.target.files[0])} />
            </div>
            {UploadProgress > 0 && <ProgressBar lable={"Uploading Image"} value={UploadProgress} />}
            <Button fullWidth className="mt-2" variant="outlined" color="error" size="small" onClick={sendLink}>
              Send Password Reset Link
            </Button>
            <Button fullWidth className="mt-2" variant="contained" color="primary" size="small" style={muiBbtn} disabled={isProcessing} onClick={updateUser}>
              {isProcessing ? <CircularProgress sx={{ color: "white" }} size={27} /> : "Update"}
            </Button>
          </form>
        </Box>
      </Modal>

      {/* VIEW COMPLETE DETAILS MODAL */}
      <Modal open={openView} onClose={handleClose}>
        <Box sx={{ ...style, width: 900, maxHeight: '95vh', overflowY: 'auto' }}>
          <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
            <div>
              <h3 className="mb-0">Complete User Details</h3>
              <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                {getUserType(fullUserData).map((type, idx) => (
                  <span 
                    key={idx}
                    style={{
                      padding: '4px 12px',
                      borderRadius: '20px',
                      backgroundColor: type === 'Diplomatic User' ? '#e3f2fd' : type === 'Premium User' ? '#f3e5f5' : '#f0f4c3',
                      color: type === 'Diplomatic User' ? '#1976d2' : type === 'Premium User' ? '#7b1fa2' : '#f57f17',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    {type}
                  </span>
                ))}
              </div>
            </div>
            <CloseIcon onClick={handleClose} style={{ cursor: "pointer", color: "gray", fontSize: "28px" }} />
          </Box>

          {/* Profile Picture */}
          <div className="text-center mb-4">
            <img 
              src={fullUserData?.photoURL || "https://via.placeholder.com/150"} 
              width="150px" 
              height="150px"
              style={{ borderRadius: '10px', objectFit: 'cover', border: '3px solid #212C62' }} 
              alt="profile" 
            />
          </div>

          {/* PERSONAL INFORMATION */}
          {(fullUserData?.displayName || fullUserData?.firstName || fullUserData?.lastName || fullUserData?.gender) && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>👤 Personal Information</h6>
              <div className="row">
                {fullUserData?.displayName && (
                  <div className="col-md-6 mb-3">
                    <b>Display Name:</b><br />{renderFieldValue(fullUserData.displayName)}
                  </div>
                )}
                {fullUserData?.firstName && (
                  <div className="col-md-6 mb-3">
                    <b>First Name:</b><br />{renderFieldValue(fullUserData.firstName)}
                  </div>
                )}
                {fullUserData?.lastName && (
                  <div className="col-md-6 mb-3">
                    <b>Last Name:</b><br />{renderFieldValue(fullUserData.lastName)}
                  </div>
                )}
                {fullUserData?.title && (
                  <div className="col-md-6 mb-3">
                    <b>Title:</b><br />{renderFieldValue(fullUserData.title)}
                  </div>
                )}
                {fullUserData?.gender && (
                  <div className="col-md-6 mb-3">
                    <b>Gender:</b><br />{renderFieldValue(fullUserData.gender)}
                  </div>
                )}
                {fullUserData?.nationality && (
                  <div className="col-md-6 mb-3">
                    <b>Nationality:</b><br />{renderFieldValue(fullUserData.nationality)}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* CONTACT INFORMATION */}
          {(fullUserData?.email || fullUserData?.mobilePhone || fullUserData?.phoneNumber) && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>📞 Contact Information</h6>
              <div className="row">
                {fullUserData?.email && (
                  <div className="col-md-6 mb-3">
                    <b>Email:</b><br />{renderFieldValue(fullUserData.email)}
                  </div>
                )}
                {fullUserData?.mobilePhone && (
                  <div className="col-md-6 mb-3">
                    <b>Mobile Phone:</b><br />{renderFieldValue(fullUserData.mobilePhone)}
                  </div>
                )}
                {fullUserData?.phoneNumber && (
                  <div className="col-md-6 mb-3">
                    <b>Phone Number:</b><br />{renderFieldValue(fullUserData.phoneNumber)}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ADDRESS INFORMATION */}
          {(fullUserData?.address || fullUserData?.street || fullUserData?.city || fullUserData?.country || fullUserData?.zipCode) && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>📍 Address Information</h6>
              <div className="row">
                {fullUserData?.street && (
                  <div className="col-md-6 mb-3">
                    <b>Street:</b><br />{renderFieldValue(fullUserData.street)}
                  </div>
                )}
                {fullUserData?.address && (
                  <div className="col-md-6 mb-3">
                    <b>Address:</b><br />{renderFieldValue(fullUserData.address)}
                  </div>
                )}
                {fullUserData?.city && (
                  <div className="col-md-6 mb-3">
                    <b>City:</b><br />{renderFieldValue(fullUserData.city)}
                  </div>
                )}
                {fullUserData?.country && (
                  <div className="col-md-6 mb-3">
                    <b>Country:</b><br />{renderFieldValue(fullUserData.country)}
                  </div>
                )}
                {fullUserData?.zipCode && (
                  <div className="col-md-6 mb-3">
                    <b>Zip Code:</b><br />{renderFieldValue(fullUserData.zipCode)}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ACCOUNT STATUS - UPDATED with Email Verification & Online Status */}
          {(fullUserData?.subscription !== undefined || fullUserData?.disabled !== undefined || fullUserData?.created_on) && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>🔐 Account Status</h6>
              <div className="row">
                {fullUserData?.disabled !== undefined && (
                  <div className="col-md-6 mb-3">
                    <b>Account Status:</b><br />
                    {fullUserData.disabled ? (
                      <span style={{ color: '#d32f2f', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                        <CancelIcon sx={{ fontSize: '16px', mr: 0.5 }} /> Disabled
                      </span>
                    ) : (
                      <span style={{ color: '#2e7d32', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                        <CheckCircleIcon sx={{ fontSize: '16px', mr: 0.5 }} /> Active
                      </span>
                    )}
                  </div>
                )}
                {/* Email Verified from Firebase Auth */}
                <div className="col-md-6 mb-3">
                  <b>Email Verified:</b><br />
                  {fullUserData?.emailVerified ? (
                    <span style={{ color: '#2e7d32', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                      <CheckCircleIcon sx={{ fontSize: '16px', mr: 0.5 }} /> Verified
                    </span>
                  ) : (
                    <span style={{ color: '#d32f2f', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                      <CancelIcon sx={{ fontSize: '16px', mr: 0.5 }} /> Not Verified
                    </span>
                  )}
                </div>
                {/* Online Status */}
                <div className="col-md-6 mb-3">
                  <b>Online Status:</b><br />
                  {fullUserData?.online ? (
                    <span style={{ color: '#2e7d32', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                      <CircleIcon sx={{ fontSize: '12px', mr: 0.5, color: '#4caf50' }} /> Online
                    </span>
                  ) : (
                    <span style={{ color: '#d32f2f', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                      <CircleIcon sx={{ fontSize: '12px', mr: 0.5, color: '#d32f2f' }} /> Offline
                    </span>
                  )}
                </div>
                {fullUserData?.created_on && (
                  <div className="col-md-6 mb-3">
                    <b>Created On:</b><br />{renderFieldValue(fullUserData.created_on)}
                  </div>
                )}
                {fullUserData?.updated && (
                  <div className="col-md-6 mb-3">
                    <b>Last Updated:</b><br />{renderFieldValue(fullUserData.updated)}
                  </div>
                )}
                {fullUserData?.lastSeen && (
                  <div className="col-md-6 mb-3">
                    <b>Last Seen:</b><br />{renderFieldValue(fullUserData.lastSeen)}
                  </div>
                )}
                {fullUserData?.ageConfirmed !== undefined && (
                  <div className="col-md-6 mb-3">
                    <b>Age Confirmed:</b><br />
                    {renderFieldValue(fullUserData.ageConfirmed)}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* PREMIUM SUBSCRIPTION DETAILS */}
          {(fullUserData?.subscription || fullUserData?.subscriptionDuration || fullUserData?.subscriptionStart || fullUserData?.subscriptionEnd) && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f3e5f5', borderRadius: '8px' }}>
              <h6 style={{ color: '#7b1fa2', fontWeight: 'bold', marginBottom: '15px' }}>⭐ Premium Subscription</h6>
              <div className="row">
                {fullUserData?.subscription !== undefined && (
                  <div className="col-md-6 mb-3">
                    <b>Is Premium:</b><br />
                    {renderFieldValue(fullUserData.subscription)}
                  </div>
                )}
                {fullUserData?.subscriptionDuration && (
                  <div className="col-md-6 mb-3">
                    <b>Duration:</b><br />{renderFieldValue(fullUserData.subscriptionDuration)}
                  </div>
                )}
                {fullUserData?.subscriptionStart && (
                  <div className="col-md-6 mb-3">
                    <b>Start Date:</b><br />{renderFieldValue(fullUserData.subscriptionStart)}
                  </div>
                )}
                {fullUserData?.subscriptionEnd && (
                  <div className="col-md-6 mb-3">
                    <b>End Date:</b><br />{renderFieldValue(fullUserData.subscriptionEnd)}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* DIPLOMATIC STATUS */}
          {(fullUserData?.hasDiplomaticStatus || fullUserData?.jobTitle || fullUserData?.workplace || fullUserData?.workplaceCountry || fullUserData?.confirmDiplomaticTerms) && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#e3f2fd', borderRadius: '8px' }}>
              <h6 style={{ color: '#1976d2', fontWeight: 'bold', marginBottom: '15px' }}>🏛️ Diplomatic Information</h6>
              <div className="row">
                {fullUserData?.hasDiplomaticStatus !== undefined && (
                  <div className="col-md-6 mb-3">
                    <b>Has Diplomatic Status:</b><br />
                    {renderFieldValue(fullUserData.hasDiplomaticStatus)}
                  </div>
                )}
                {fullUserData?.jobTitle && (
                  <div className="col-md-6 mb-3">
                    <b>Job Title:</b><br />{renderFieldValue(fullUserData.jobTitle)}
                  </div>
                )}
                {fullUserData?.workplace && (
                  <div className="col-md-6 mb-3">
                    <b>Workplace:</b><br />{renderFieldValue(fullUserData.workplace)}
                  </div>
                )}
                {fullUserData?.workplaceName && (
                  <div className="col-md-6 mb-3">
                    <b>Workplace Name:</b><br />{renderFieldValue(fullUserData.workplaceName)}
                  </div>
                )}
                {fullUserData?.workplaceCountry && (
                  <div className="col-md-6 mb-3">
                    <b>Workplace Country:</b><br />{renderFieldValue(fullUserData.workplaceCountry)}
                  </div>
                )}
                {fullUserData?.confirmDiplomaticTerms !== undefined && (
                  <div className="col-md-6 mb-3">
                    <b>Confirmed Diplomatic Terms:</b><br />
                    {renderFieldValue(fullUserData.confirmDiplomaticTerms)}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* PREFERENCES & SETTINGS */}
          {(fullUserData?.preferredCurrency || fullUserData?.enableNewsNotification !== undefined || fullUserData?.newsNotificationTime || fullUserData?.enabledNewsCountries) && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>⚙️ Preferences & Settings</h6>
              <div className="row">
                {fullUserData?.preferredCurrency && (
                  <div className="col-md-6 mb-3">
                    <b>Preferred Currency:</b><br />{renderFieldValue(fullUserData.preferredCurrency)}
                  </div>
                )}
                {fullUserData?.enableNewsNotification !== undefined && (
                  <div className="col-md-6 mb-3">
                    <b>News Notifications Enabled:</b><br />
                    {renderFieldValue(fullUserData.enableNewsNotification)}
                  </div>
                )}
                {fullUserData?.newsNotificationTime && fullUserData?.enableNewsNotification && (
                  <div className="col-md-6 mb-3">
                    <b>Notification Time:</b><br />{renderFieldValue(fullUserData.newsNotificationTime)}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* DEVICE & SECURITY INFO */}
          {(fullUserData?.deviceToken || fullUserData?.fingerprint !== undefined) && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>📱 Device & Security</h6>
              <div className="row">
                {fullUserData?.deviceToken && (
                  <div className="col-12 mb-3">
                    <b>Device Token:</b><br />
                    <small className="text-muted" style={{ wordBreak: 'break-all' }}>
                      {fullUserData.deviceToken}
                    </small>
                  </div>
                )}
                {fullUserData?.fingerprint !== undefined && (
                  <div className="col-md-6 mb-3">
                    <b>Fingerprint Auth:</b><br />
                    {renderFieldValue(fullUserData.fingerprint)}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* REGISTRATION SECURITY DATA */}
          {securityData && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#fff3e0', borderRadius: '8px' }}>
              <h6 style={{ color: '#e65100', fontWeight: 'bold', marginBottom: '15px' }}>🛡️ Registration Security Info</h6>
              
              <div className="row small">
                {securityData.browser && (
                  <div className="col-md-6 mb-3">
                    <p className="mb-1"><strong>Device & Browser</strong></p>
                    Browser: {securityData.browser?.name} (v{securityData.browser?.version})<br />
                    Platform: {securityData.platform}<br />
                    Language: {securityData.language}
                  </div>
                )}
                {securityData.ipInfo && (
                  <div className="col-md-6 mb-3">
                    <p className="mb-1"><strong>Location & Network</strong></p>
                    IP: {securityData.ipInfo?.ip}<br />
                    City: {securityData.ipInfo?.city}, {securityData.ipInfo?.countryCode}<br />
                    Region: {securityData.ipInfo?.region}<br />
                    Timezone: {securityData.ipInfo?.timezone}
                  </div>
                )}
                <div className="col-12 mb-3">
                  <p className="mb-1"><strong>Technical Details</strong></p>
                  <small className="text-muted" style={{ wordBreak: 'break-all' }}>
                    UA: {securityData.userAgent}
                  </small>
                </div>
                {securityData.registrationTimestamp && (
                  <div className="col-12">
                    <strong>Registered On:</strong> {new Date(securityData.registrationTimestamp).toLocaleString()}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ADDITIONAL DATA */}
          {(fullUserData?.total_amount || fullUserData?.cart || fullUserData?.saved || fullUserData?.favorites) && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>📊 Additional Information</h6>
              <div className="row">
                {fullUserData?.total_amount !== undefined && (
                  <div className="col-md-6 mb-3">
                    <b>Total Amount:</b><br />{renderFieldValue(fullUserData.total_amount)}
                  </div>
                )}
                {fullUserData?.cart && (
                  <div className="col-md-6 mb-3">
                    <b>Shopping Cart:</b><br />{renderFieldValue(fullUserData.cart)}
                  </div>
                )}
                {fullUserData?.saved && (
                  <div className="col-md-6 mb-3">
                    <b>Saved Items:</b><br />{renderFieldValue(fullUserData.saved)}
                  </div>
                )}
                {fullUserData?.favorites && (
                  <div className="col-md-6 mb-3">
                    <b>Favorites:</b><br />{renderFieldValue(fullUserData.favorites)}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* UID */}
          {fullUserData?.uid && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>🔑 User ID</h6>
              <small className="text-muted" style={{ wordBreak: 'break-all' }}>
                {fullUserData.uid}
              </small>
            </div>
          )}
        </Box>
      </Modal>

      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6 mb-4 py-4">
            <h1 style={{ textAlign: "left", color: "#212C62" }}><b>All Users</b></h1>
            <span className="text-muted">User Management Dashboard</span>
          </div>
          <div className="col-6 d-flex justify-content-end" style={{ marginTop: "-30px" }}>
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <DataGrid
            style={{ height: "65vh", width: "100%" }}
            columns={columns}
            rows={rows}
            pageSize={6}
            rowsPerPageOptions={[5]}
            loading={loading}
            disableColumnMenu={true}
            headerHeight={0}
            disableSelectionOnClick
            getRowSpacing={(params) => ({
              top: params.isFirstVisible ? 10 : 8,
              bottom: params.isLastVisible ? 0 : 8,
            })}
          />
        </div>
      </Card>
    </div>
  );
}

// import React, { useState, useEffect } from "react";
// import "./css/styles.css";
// import { DataGrid } from "@mui/x-data-grid";
// import {
//   Card,
//   Dialog,
//   DialogActions,
//   DialogTitle,
//   Button,
//   TextField,
//   FormControl,
//   Box,
//   Modal,
// } from "@mui/material";
// import PortraitIcon from "@mui/icons-material/Portrait";
// import { modalstyle, muiAbtn, muiBbtn } from "./style";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
// import EditIcon from "@mui/icons-material/Edit";
// import CloseIcon from "@mui/icons-material/Close";
// import StarIcon from "@mui/icons-material/Star";
// import AddIcon from "@mui/icons-material/Add";
// import Rating from "@mui/material/Rating";
// import CreativeImage from "./CreativeImage";
// import { getFunctions, httpsCallable } from "firebase/functions";

// import {
//   collection,
//   getDocs,
//   setDoc,
//   addDoc,
//   updateDoc,
//   doc,
//   query,
//   orderBy,
//   deleteDoc,
//   onSnapshot,
//   limit,
//   where,
//   getDoc,
// } from "firebase/firestore";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { db, storage } from "../firebase";
// import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

// import {
//   getDownloadURL,
//   uploadBytesResumable,
//   ref,
//   uploadBytes,
// } from "firebase/storage";
// import { useAuth } from "./AuthContext";
// import ProgressBar from "./ProgressBar";
// import CircularProgress from "@mui/material/CircularProgress";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 500,
//   bgcolor: "#fff",
//   boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
//   p: 4,
//   borderRadius: 2,
// };

// export default function Categories() {
//   const { ResetPassword } = useAuth();

//   const functions = getFunctions();
//   const updateUserData = httpsCallable(functions, "updateUserData");

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [updateID, setupdateID] = useState(-1);
//   const [Name, setName] = useState("");
//   const [Email, setEmail] = useState("");
//   const [Phone, setPhone] = useState("");
//   const [UploadImage, setUploadImage] = useState(null);
//   const [gender, setGender] = useState("");
//   const [Profile, setProfile] = useState("");
//   const [UploadProgress, setUploadProgress] = useState(0);
//   const [status, setstatus] = useState(false); // This is the 'disabled' field
//   const [isProcessing, setisProcessing] = useState(false);
  
//   // State for complete user data
//   const [fullUserData, setFullUserData] = useState({});
//   const [securityData, setSecurityData] = useState(null);
  
//   // Helper function to determine user type
//   const getUserType = (userData) => {
//     const types = [];
    
//     if (userData?.hasDiplomaticStatus) {
//       types.push('Diplomatic User');
//     }
//     if (userData?.subscription) {
//       types.push('Premium User');
//     }
//     if (types.length === 0) {
//       types.push('Simple User');
//     }
    
//     return types;
//   };
  
//   // Helper function to render field value
//   const renderFieldValue = (value) => {
//     if (value === null || value === undefined || value === '') {
//       return <span className="text-muted">N/A</span>;
//     }
//     if (typeof value === 'boolean') {
//       return value ? (
//         <span style={{ color: '#2e7d32', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
//           <CheckCircleIcon sx={{ fontSize: '16px', mr: 0.5 }} /> Yes
//         </span>
//       ) : (
//         <span style={{ color: '#d32f2f', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
//           <CancelIcon sx={{ fontSize: '16px', mr: 0.5 }} /> No
//         </span>
//       );
//     }
//     if (value?.seconds) {
//       return new Date(value.seconds * 1000).toLocaleString();
//     }
//     if (value instanceof Date) {
//       return value.toLocaleString();
//     }
//     if (Array.isArray(value)) {
//       return value.length > 0 ? `${value.length} item(s)` : <span className="text-muted">Empty</span>;
//     }
//     if (typeof value === 'object') {
//       return JSON.stringify(value).substring(0, 50) + '...';
//     }
//     return String(value);
//   };

//   useEffect(() => {
//     const getData = async () => {
//       setLoading(true);
//       onSnapshot(
//         query(collection(db, "users"), orderBy("created_on", "desc")),
//         (data) => {
//           const fetchedRows = data.docs.map((document) => ({
//             ...document.data(),
//             id: document.id,
//           }));
//           setRows(fetchedRows);
//           setLoading(false);
//         }
//       );
//     };
//     getData();
//   }, []);

//   const [open, setOpen] = useState(false);
//   const [SelectedUser, setSelectedUser] = useState("");
//   const [openView, setOpenView] = useState(false);

//   const fetchUserData = async (index) => {
//     const docRef = doc(db, "users", index);
//     const docSnap = await getDoc(docRef);
    
//     if (docSnap.exists()) {
//       const data = docSnap.data();
      
//       // Store complete user data
//       setFullUserData(data);
      
//       // Store form fields for editing
//       setName(data.displayName || "");
//       setEmail(data.email || "");
//       setPhone(data.phoneNumber || "");
//       setstatus(data.disabled || false);
//       setGender(data.gender || "");
//       setProfile(data.photoURL || "");
      
//       // Load the registrationSecurity JSON
//       if (data.registrationSecurity) {
//         setSecurityData(data.registrationSecurity);
//       } else {
//         setSecurityData(null);
//       }
//     }
//   };

//   const resetForm = () => {
//     setName("");
//     setEmail("");
//     setPhone("");
//     setstatus(false);
//     setGender("");
//     setProfile("");
//     setSecurityData(null);
//     setUploadProgress(0);
//   };

//   const handleOpen = async (index) => {
//     setupdateID(index);
//     setOpen(true);
//     fetchUserData(index);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setOpenView(false);
//     resetForm();
//   };

//   const handleOpenView = (index) => {
//     setOpenView(true);
//     fetchUserData(index);
//   };

//   const [openDialog, setOpenDialog] = React.useState(false);

//   const handleClickOpen = (id) => {
//     setOpenDialog(true);
//     setSelectedUser(id);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedUser("");
//   };

//   const deleteUser = () => {
//     deleteDoc(doc(db, "users", SelectedUser))
//       .then(() => {
//         toast.info("User Deleted");
//         handleCloseDialog();
//       })
//       .catch((error) => {
//         toast.error("Error! Failed to delete user");
//       });
//   };

//   const updateUser = () => {
//     setisProcessing(true);
//     let data = {
//       displayName: Name,
//       email: Email,
//       phoneNumber: Phone,
//       gender: gender,
//       photoURL: Profile,
//       updated: new Date(),
//       uid: updateID,
//       disabled: status,
//     };

//     if (UploadImage) {
//       const storageRef = ref(storage, `/profile_images/profile_image_user_${updateID}`);
//       const uploadTask = uploadBytesResumable(storageRef, UploadImage);

//       uploadTask.on(
//         "state_changed",
//         (snapshot) => {
//           const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
//           setUploadProgress(percent);
//         },
//         (err) => {
//           console.log(err);
//           setisProcessing(false);
//         },
//         () => {
//           getDownloadURL(uploadTask.snapshot.ref).then((url) => {
//             data.photoURL = url;
//             updateUserData(data).then(() => {
//               updateDoc(doc(db, "users", updateID), data).then(() => {
//                 setisProcessing(false);
//                 toast.info("User Updated");
//                 handleClose();
//               });
//             });
//           });
//         }
//       );
//     } else {
//       updateUserData(data)
//         .then(() => {
//           updateDoc(doc(db, "users", updateID), data).then(() => {
//             setisProcessing(false);
//             toast.info("User Updated");
//             handleClose();
//           });
//         })
//         .catch((error) => {
//           setisProcessing(false);
//           toast.error(error.message);
//         });
//     }
//   };

//   const sendLink = () => {
//     ResetPassword(Email)
//       .then(() => {
//         toast.success("Link Has Been Sent To " + Email);
//       })
//       .catch((error) => {
//         toast.error(error.message);
//       });
//   };

//   const columns = [
//     {
//       field: "Profile",
//       headerName: "",
//       width: 500,
//       align: "left",
//       renderCell: profileCell,
//     },
//     {
//       field: "Action",
//       width: 400,
//       align: "right",
//       renderCell: ActionButton,
//     },
//   ];

//   function profileCell(params) {
//     return (
//       <div className="row">
//         <div className="col-4">
//           <img
//             width="50px"
//             className="rounded-4"
//             height="50px"
//             src={params.row.photoURL || "https://via.placeholder.com/50"}
//             alt="profile"
//           />
//         </div>
//         <div className="col-8 d-flex justify-content-left flex-wrap align-items-center">
//           <span className="ms-1">
//             <b>{params.row.displayName}</b>
//             <br />
//             <small className="text-muted">
//               {params.row.created_on 
//                 ? new Date(params.row.created_on.seconds * 1000).toLocaleDateString()
//                 : "N/A"}
//               <FiberManualRecordIcon sx={{ fontSize: "5px", mx: 1 }} />
//               <b role="button" onClick={() => handleOpenView(params.row.id)}>
//                 Details
//               </b>
//             </small>
//           </span>
//         </div>
//       </div>
//     );
//   }

//   function ActionButton(params) {
//     return (
//       <>
//         <Button
//           variant="contained"
//           color="primary"
//           style={muiAbtn}
//           size="small"
//           onClick={() => handleOpen(params.row.id)}
//         >
//           Edit
//         </Button>
//         <Button
//           variant="contained"
//           color="primary"
//           size="small"
//           style={muiAbtn}
//           onClick={() => handleClickOpen(params.row.id)}
//         >
//           Delete
//         </Button>
//       </>
//     );
//   }

//   return (
//     <div
//       style={{
//         width: "100%",
//         padding: 40,
//         backgroundColor: "#212C62",
//         minHeight: "100vh"
//       }}
//     >
//       <Dialog open={openDialog} onClose={handleCloseDialog}>
//         <DialogTitle>{"Are you sure to Delete the User?"}</DialogTitle>
//         <DialogActions>
//           <Button onClick={() => deleteUser()}>Yes</Button>
//           <Button onClick={handleCloseDialog} autoFocus>No</Button>
//         </DialogActions>
//       </Dialog>

//       <ToastContainer position="top-center" theme="colored" />

//       {/* EDIT MODAL */}
//       <Modal open={open} onClose={handleClose}>
//         <Box sx={style}>
//           <form>
//             <Box mb={3} style={{ display: "flex", justifyContent: "end" }}>
//               <CloseIcon onClick={handleClose} style={{ cursor: "pointer", color: "gray" }} />
//             </Box>
//             <FormControl fullWidth size="small">
//               <TextField className="mb-4" label="Name" size="small" fullWidth value={Name} onChange={(e) => setName(e.target.value)} />
//             </FormControl>
//             <FormControl fullWidth size="small">
//               <TextField className="mb-4" label="Email" size="small" fullWidth value={Email} onChange={(e) => setEmail(e.target.value)} />
//             </FormControl>
//             <FormControl fullWidth size="small">
//               <TextField className="mb-4" label="Phone" size="small" fullWidth value={Phone} onChange={(e) => setPhone(e.target.value)} />
//             </FormControl>
//             <div className="row">
//               <div className="col">
//                 <FormControl fullWidth className="mb-4" size="small">
//                   <InputLabel>Status</InputLabel>
//                   <Select value={status} label="Status" onChange={(e) => setstatus(e.target.value)}>
//                     <MenuItem value={false}>Active</MenuItem>
//                     <MenuItem value={true}>Disable</MenuItem>
//                   </Select>
//                 </FormControl>
//               </div>
//               <div className="col">
//                 <FormControl fullWidth className="mb-4" size="small">
//                   <InputLabel>Gender</InputLabel>
//                   <Select value={gender} label="Gender" onChange={(e) => setGender(e.target.value)}>
//                     <MenuItem value={"Male"}>Male</MenuItem>
//                     <MenuItem value={"Female"}>Female</MenuItem>
//                     <MenuItem value={"Other"}>Other</MenuItem>
//                   </Select>
//                 </FormControl>
//               </div>
//             </div>
//             <div className="mb-4">
//               <label className="form-label"><b>Change Profile</b></label>
//               <input type="file" accept="image/*" className="form-control" onChange={(e) => setUploadImage(e.target.files[0])} />
//             </div>
//             {UploadProgress > 0 && <ProgressBar lable={"Uploading Image"} value={UploadProgress} />}
//             <Button fullWidth className="mt-2" variant="outlined" color="error" size="small" onClick={sendLink}>
//               Send Password Reset Link
//             </Button>
//             <Button fullWidth className="mt-2" variant="contained" color="primary" size="small" style={muiBbtn} disabled={isProcessing} onClick={updateUser}>
//               {isProcessing ? <CircularProgress sx={{ color: "white" }} size={27} /> : "Update"}
//             </Button>
//           </form>
//         </Box>
//       </Modal>

//       {/* VIEW COMPLETE DETAILS MODAL */}
//       <Modal open={openView} onClose={handleClose}>
//         <Box sx={{ ...style, width: 900, maxHeight: '95vh', overflowY: 'auto' }}>
//           <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
//             <div>
//               <h3 className="mb-0">Complete User Details</h3>
//               <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
//                 {getUserType(fullUserData).map((type, idx) => (
//                   <span 
//                     key={idx}
//                     style={{
//                       padding: '4px 12px',
//                       borderRadius: '20px',
//                       backgroundColor: type === 'Diplomatic User' ? '#e3f2fd' : type === 'Premium User' ? '#f3e5f5' : '#f0f4c3',
//                       color: type === 'Diplomatic User' ? '#1976d2' : type === 'Premium User' ? '#7b1fa2' : '#f57f17',
//                       fontSize: '12px',
//                       fontWeight: 'bold'
//                     }}
//                   >
//                     {type}
//                   </span>
//                 ))}
//               </div>
//             </div>
//             <CloseIcon onClick={handleClose} style={{ cursor: "pointer", color: "gray", fontSize: "28px" }} />
//           </Box>

//           {/* Profile Picture */}
//           <div className="text-center mb-4">
//             <img 
//               src={fullUserData?.photoURL || "https://via.placeholder.com/150"} 
//               width="150px" 
//               height="150px"
//               style={{ borderRadius: '10px', objectFit: 'cover', border: '3px solid #212C62' }} 
//               alt="profile" 
//             />
//           </div>

//           {/* PERSONAL INFORMATION */}
//           {(fullUserData?.displayName || fullUserData?.firstName || fullUserData?.lastName || fullUserData?.gender) && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
//               <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>👤 Personal Information</h6>
//               <div className="row">
//                 {fullUserData?.displayName && (
//                   <div className="col-md-6 mb-3">
//                     <b>Display Name:</b><br />{renderFieldValue(fullUserData.displayName)}
//                   </div>
//                 )}
//                 {fullUserData?.firstName && (
//                   <div className="col-md-6 mb-3">
//                     <b>First Name:</b><br />{renderFieldValue(fullUserData.firstName)}
//                   </div>
//                 )}
//                 {fullUserData?.lastName && (
//                   <div className="col-md-6 mb-3">
//                     <b>Last Name:</b><br />{renderFieldValue(fullUserData.lastName)}
//                   </div>
//                 )}
//                 {fullUserData?.title && (
//                   <div className="col-md-6 mb-3">
//                     <b>Title:</b><br />{renderFieldValue(fullUserData.title)}
//                   </div>
//                 )}
//                 {fullUserData?.gender && (
//                   <div className="col-md-6 mb-3">
//                     <b>Gender:</b><br />{renderFieldValue(fullUserData.gender)}
//                   </div>
//                 )}
//                 {fullUserData?.nationality && (
//                   <div className="col-md-6 mb-3">
//                     <b>Nationality:</b><br />{renderFieldValue(fullUserData.nationality)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* CONTACT INFORMATION */}
//           {(fullUserData?.email || fullUserData?.mobilePhone || fullUserData?.phoneNumber) && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
//               <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>📞 Contact Information</h6>
//               <div className="row">
//                 {fullUserData?.email && (
//                   <div className="col-md-6 mb-3">
//                     <b>Email:</b><br />{renderFieldValue(fullUserData.email)}
//                   </div>
//                 )}
//                 {fullUserData?.mobilePhone && (
//                   <div className="col-md-6 mb-3">
//                     <b>Mobile Phone:</b><br />{renderFieldValue(fullUserData.mobilePhone)}
//                   </div>
//                 )}
//                 {fullUserData?.phoneNumber && (
//                   <div className="col-md-6 mb-3">
//                     <b>Phone Number:</b><br />{renderFieldValue(fullUserData.phoneNumber)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* ADDRESS INFORMATION */}
//           {(fullUserData?.address || fullUserData?.street || fullUserData?.city || fullUserData?.country || fullUserData?.zipCode) && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
//               <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>📍 Address Information</h6>
//               <div className="row">
//                 {fullUserData?.street && (
//                   <div className="col-md-6 mb-3">
//                     <b>Street:</b><br />{renderFieldValue(fullUserData.street)}
//                   </div>
//                 )}
//                 {fullUserData?.address && (
//                   <div className="col-md-6 mb-3">
//                     <b>Address:</b><br />{renderFieldValue(fullUserData.address)}
//                   </div>
//                 )}
//                 {fullUserData?.city && (
//                   <div className="col-md-6 mb-3">
//                     <b>City:</b><br />{renderFieldValue(fullUserData.city)}
//                   </div>
//                 )}
//                 {fullUserData?.country && (
//                   <div className="col-md-6 mb-3">
//                     <b>Country:</b><br />{renderFieldValue(fullUserData.country)}
//                   </div>
//                 )}
//                 {fullUserData?.zipCode && (
//                   <div className="col-md-6 mb-3">
//                     <b>Zip Code:</b><br />{renderFieldValue(fullUserData.zipCode)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* ACCOUNT STATUS */}
//           {(fullUserData?.subscription !== undefined || fullUserData?.disabled !== undefined || fullUserData?.created_on) && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
//               <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>🔐 Account Status</h6>
//               <div className="row">
//                 {fullUserData?.disabled !== undefined && (
//                   <div className="col-md-6 mb-3">
//                     <b>Account Status:</b><br />
//                     {renderFieldValue(fullUserData.disabled)}
//                   </div>
//                 )}
//                 {fullUserData?.online !== undefined && (
//                   <div className="col-md-6 mb-3">
//                     <b>Online Status:</b><br />
//                     {renderFieldValue(fullUserData.online)}
//                   </div>
//                 )}
//                 {fullUserData?.created_on && (
//                   <div className="col-md-6 mb-3">
//                     <b>Created On:</b><br />{renderFieldValue(fullUserData.created_on)}
//                   </div>
//                 )}
//                 {fullUserData?.updated && (
//                   <div className="col-md-6 mb-3">
//                     <b>Last Updated:</b><br />{renderFieldValue(fullUserData.updated)}
//                   </div>
//                 )}
//                 {fullUserData?.ageConfirmed !== undefined && (
//                   <div className="col-md-6 mb-3">
//                     <b>Age Confirmed:</b><br />
//                     {renderFieldValue(fullUserData.ageConfirmed)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* PREMIUM SUBSCRIPTION DETAILS */}
//           {(fullUserData?.subscription || fullUserData?.subscriptionDuration || fullUserData?.subscriptionStart || fullUserData?.subscriptionEnd) && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#f3e5f5', borderRadius: '8px' }}>
//               <h6 style={{ color: '#7b1fa2', fontWeight: 'bold', marginBottom: '15px' }}>⭐ Premium Subscription</h6>
//               <div className="row">
//                 {fullUserData?.subscription !== undefined && (
//                   <div className="col-md-6 mb-3">
//                     <b>Is Premium:</b><br />
//                     {renderFieldValue(fullUserData.subscription)}
//                   </div>
//                 )}
//                 {fullUserData?.subscriptionDuration && (
//                   <div className="col-md-6 mb-3">
//                     <b>Duration:</b><br />{renderFieldValue(fullUserData.subscriptionDuration)}
//                   </div>
//                 )}
//                 {fullUserData?.subscriptionStart && (
//                   <div className="col-md-6 mb-3">
//                     <b>Start Date:</b><br />{renderFieldValue(fullUserData.subscriptionStart)}
//                   </div>
//                 )}
//                 {fullUserData?.subscriptionEnd && (
//                   <div className="col-md-6 mb-3">
//                     <b>End Date:</b><br />{renderFieldValue(fullUserData.subscriptionEnd)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* DIPLOMATIC STATUS */}
//           {(fullUserData?.hasDiplomaticStatus || fullUserData?.jobTitle || fullUserData?.workplace || fullUserData?.workplaceCountry || fullUserData?.confirmDiplomaticTerms) && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#e3f2fd', borderRadius: '8px' }}>
//               <h6 style={{ color: '#1976d2', fontWeight: 'bold', marginBottom: '15px' }}>🏛️ Diplomatic Information</h6>
//               <div className="row">
//                 {fullUserData?.hasDiplomaticStatus !== undefined && (
//                   <div className="col-md-6 mb-3">
//                     <b>Has Diplomatic Status:</b><br />
//                     {renderFieldValue(fullUserData.hasDiplomaticStatus)}
//                   </div>
//                 )}
//                 {fullUserData?.jobTitle && (
//                   <div className="col-md-6 mb-3">
//                     <b>Job Title:</b><br />{renderFieldValue(fullUserData.jobTitle)}
//                   </div>
//                 )}
//                 {fullUserData?.workplace && (
//                   <div className="col-md-6 mb-3">
//                     <b>Workplace:</b><br />{renderFieldValue(fullUserData.workplace)}
//                   </div>
//                 )}
//                 {fullUserData?.workplaceName && (
//                   <div className="col-md-6 mb-3">
//                     <b>Workplace Name:</b><br />{renderFieldValue(fullUserData.workplaceName)}
//                   </div>
//                 )}
//                 {fullUserData?.workplaceCountry && (
//                   <div className="col-md-6 mb-3">
//                     <b>Workplace Country:</b><br />{renderFieldValue(fullUserData.workplaceCountry)}
//                   </div>
//                 )}
//                 {fullUserData?.confirmDiplomaticTerms !== undefined && (
//                   <div className="col-md-6 mb-3">
//                     <b>Confirmed Diplomatic Terms:</b><br />
//                     {renderFieldValue(fullUserData.confirmDiplomaticTerms)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* PREFERENCES & SETTINGS */}
//           {(fullUserData?.preferredCurrency || fullUserData?.enableNewsNotification !== undefined || fullUserData?.newsNotificationTime || fullUserData?.enabledNewsCountries) && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
//               <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>⚙️ Preferences & Settings</h6>
//               <div className="row">
//                 {fullUserData?.preferredCurrency && (
//                   <div className="col-md-6 mb-3">
//                     <b>Preferred Currency:</b><br />{renderFieldValue(fullUserData.preferredCurrency)}
//                   </div>
//                 )}
//                 {fullUserData?.enableNewsNotification !== undefined && (
//                   <div className="col-md-6 mb-3">
//                     <b>News Notifications Enabled:</b><br />
//                     {renderFieldValue(fullUserData.enableNewsNotification)}
//                   </div>
//                 )}
//                 {fullUserData?.newsNotificationTime && fullUserData?.enableNewsNotification && (
//                   <div className="col-md-6 mb-3">
//                     <b>Notification Time:</b><br />{renderFieldValue(fullUserData.newsNotificationTime)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* DEVICE & SECURITY INFO */}
//           {(fullUserData?.deviceToken || fullUserData?.fingerprint !== undefined) && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
//               <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>📱 Device & Security</h6>
//               <div className="row">
//                 {fullUserData?.deviceToken && (
//                   <div className="col-12 mb-3">
//                     <b>Device Token:</b><br />
//                     <small className="text-muted" style={{ wordBreak: 'break-all' }}>
//                       {fullUserData.deviceToken}
//                     </small>
//                   </div>
//                 )}
//                 {fullUserData?.fingerprint !== undefined && (
//                   <div className="col-md-6 mb-3">
//                     <b>Fingerprint Auth:</b><br />
//                     {renderFieldValue(fullUserData.fingerprint)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* REGISTRATION SECURITY DATA */}
//           {securityData && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#fff3e0', borderRadius: '8px' }}>
//               <h6 style={{ color: '#e65100', fontWeight: 'bold', marginBottom: '15px' }}>🛡️ Registration Security Info</h6>
              
//               <div className="row small">
//                 {securityData.browser && (
//                   <div className="col-md-6 mb-3">
//                     <p className="mb-1"><strong>Device & Browser</strong></p>
//                     Browser: {securityData.browser?.name} (v{securityData.browser?.version})<br />
//                     Platform: {securityData.platform}<br />
//                     Language: {securityData.language}
//                   </div>
//                 )}
//                 {securityData.ipInfo && (
//                   <div className="col-md-6 mb-3">
//                     <p className="mb-1"><strong>Location & Network</strong></p>
//                     IP: {securityData.ipInfo?.ip}<br />
//                     City: {securityData.ipInfo?.city}, {securityData.ipInfo?.countryCode}<br />
//                     Region: {securityData.ipInfo?.region}<br />
//                     Timezone: {securityData.ipInfo?.timezone}
//                   </div>
//                 )}
//                 <div className="col-12 mb-3">
//                   <p className="mb-1"><strong>Technical Details</strong></p>
//                   <small className="text-muted" style={{ wordBreak: 'break-all' }}>
//                     UA: {securityData.userAgent}
//                   </small>
//                 </div>
//                 {securityData.registrationTimestamp && (
//                   <div className="col-12">
//                     <strong>Registered On:</strong> {new Date(securityData.registrationTimestamp).toLocaleString()}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* ADDITIONAL DATA */}
//           {(fullUserData?.total_amount || fullUserData?.cart || fullUserData?.saved || fullUserData?.favorites) && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
//               <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>📊 Additional Information</h6>
//               <div className="row">
//                 {fullUserData?.total_amount !== undefined && (
//                   <div className="col-md-6 mb-3">
//                     <b>Total Amount:</b><br />{renderFieldValue(fullUserData.total_amount)}
//                   </div>
//                 )}
//                 {fullUserData?.cart && (
//                   <div className="col-md-6 mb-3">
//                     <b>Shopping Cart:</b><br />{renderFieldValue(fullUserData.cart)}
//                   </div>
//                 )}
//                 {fullUserData?.saved && (
//                   <div className="col-md-6 mb-3">
//                     <b>Saved Items:</b><br />{renderFieldValue(fullUserData.saved)}
//                   </div>
//                 )}
//                 {fullUserData?.favorites && (
//                   <div className="col-md-6 mb-3">
//                     <b>Favorites:</b><br />{renderFieldValue(fullUserData.favorites)}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* UID */}
//           {fullUserData?.uid && (
//             <div className="mb-4 p-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
//               <h6 style={{ color: '#212C62', fontWeight: 'bold', marginBottom: '15px' }}>🔑 User ID</h6>
//               <small className="text-muted" style={{ wordBreak: 'break-all' }}>
//                 {fullUserData.uid}
//               </small>
//             </div>
//           )}
//         </Box>
//       </Modal>

//       <Card style={{ padding: 50, borderRadius: 10 }}>
//         <div className="row d-flex justify-content-between">
//           <div className="col-6 mb-4 py-4">
//             <h1 style={{ textAlign: "left", color: "#212C62" }}><b>All Users</b></h1>
//             <span className="text-muted">User Management Dashboard</span>
//           </div>
//           <div className="col-6 d-flex justify-content-end" style={{ marginTop: "-30px" }}>
//             <CreativeImage />
//           </div>
//         </div>
//         <div className="mt-2">
//           <DataGrid
//             style={{ height: "65vh", width: "100%" }}
//             columns={columns}
//             rows={rows}
//             pageSize={6}
//             rowsPerPageOptions={[5]}
//             loading={loading}
//             disableColumnMenu={true}
//             headerHeight={0}
//             disableSelectionOnClick
//             getRowSpacing={(params) => ({
//               top: params.isFirstVisible ? 10 : 8,
//               bottom: params.isLastVisible ? 0 : 8,
//             })}
//           />
//         </div>
//       </Card>
//     </div>
//   );
// }